import React from 'react';
import { Page, Layout } from '@shopify/polaris';

import Orders from '../componets/orders';

const Home = () => {

    return (
        <Page
            title="Orders with Digital Download" separator>
            <Layout>
                <Layout.Section>

                    <Orders url="/orders/all-custom-order" />

                </Layout.Section>
            </Layout>

        </Page>
    )
}

export default Home;